import { render, staticRenderFns } from "./InfoChart.vue?vue&type=template&id=3076c9d4&scoped=true"
import script from "./InfoChart.vue?vue&type=script&lang=js"
export * from "./InfoChart.vue?vue&type=script&lang=js"
import style0 from "./InfoChart.vue?vue&type=style&index=0&id=3076c9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076c9d4",
  null
  
)

export default component.exports